import { useWeb3React } from '@web3-react/core';
import useSWR from 'swr';
import abis from '../../config/abis';
import { fetcher } from '../../web3/utils';

const useTokenDetails = (tokenAddress: string | undefined) => {
    const { library } = useWeb3React();

    const { data: symbol, error: symbolError } = useSWR([tokenAddress ?? '', 'symbol'], {
        fetcher: fetcher(library, abis.erc20),
    });

    const { data: decimals, error: decimalsError } = useSWR(
        [tokenAddress ?? '', 'decimals'],
        {
            fetcher: fetcher(library, abis.erc20),
        }
    );

    return {
        symbol,
        decimals: decimals?.toString(),
        isLoading: !symbol && !decimals && !symbolError && !decimalsError,
    };
};

export default useTokenDetails;
